var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmailNew = function SvgEmailNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#email_new_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#001731",
    stroke: "#171D38",
    strokeWidth: 0.971,
    d: "M12.5.985c6.349 0 11.515 5.167 11.515 11.515S18.849 24.015 12.5 24.015.985 18.849.985 12.5C.985 6.152 6.151.985 12.5.985Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.875 18h8.25C17.71 18 19 16.738 19 15.185v-5.37C19 8.262 17.71 7 16.125 7h-8.25C6.29 7 5 8.262 5 9.815v5.37C5 16.738 6.29 18 7.875 18m8.25-1.082h-8.25c-.976 0-1.77-.777-1.77-1.733V10.19l4.315 2.896a2.83 2.83 0 0 0 1.58.476 2.83 2.83 0 0 0 1.58-.476l4.315-2.896v4.995c0 .956-.794 1.733-1.77 1.733m-8.25-8.836h8.25c.681 0 1.273.379 1.568.932l-4.738 3.182a1.73 1.73 0 0 1-1.908 0L6.309 9.014a1.78 1.78 0 0 1 1.568-.932z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "email_new_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5.5h24v24H.5z"
  })))));
};
export default SvgEmailNew;